import { render, staticRenderFns } from "./FrequencyField.vue?vue&type=template&id=3734df54&scoped=true"
import script from "./FrequencyField.vue?vue&type=script&lang=js"
export * from "./FrequencyField.vue?vue&type=script&lang=js"
import style0 from "./FrequencyField.vue?vue&type=style&index=0&id=3734df54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3734df54",
  null
  
)

export default component.exports